import { all } from 'redux-saga/effects';

import sagaUsuario from './usuario';

export default function* rootSaga() {
  yield all([
    sagaUsuario(),
  ]);
}
